import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {Subject} from "rxjs";
import {DinamicLoaderService} from "../services/dinamic-loader.service";
import {SidenavService} from "../services/sidenav.service";
import {ClientInterface} from "../interfaces/client.interface";
import {UserFormComponent} from "./user-form/user-form.component";
import {cloneDeep} from 'lodash-es';
import {SettingsService} from "../services/settings.service";
import {MatButtonModule} from "@angular/material/button";
import {DatePipe, JsonPipe} from "@angular/common";
import {FormlyFieldConfig, FormlyModule} from "@ngx-formly/core";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {OrganizationInterface} from "../interfaces/organization.interface";
import {OrganizationService} from "../services/organization.service";
import {takeUntil} from "rxjs/operators";


@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    JsonPipe,
    DatePipe,
    FormlyModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent implements OnInit, OnDestroy {

  @ViewChild(MatSort, {static: true}) sort: MatSort | undefined;

  displayedColumns: string[] = ['num', 'fio', 'login', 'phone', 'dateCreation'];

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([])

  data: any = [];
  form = new FormGroup({
    organization: new FormControl()
  });
  fields: FormlyFieldConfig[] = [];
  model: any = {};
  options: { label: string, value: OrganizationInterface }[] = [];
  organization: OrganizationInterface | undefined;


  private unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private dinamicLoaderService: DinamicLoaderService,
    private sidenavService: SidenavService,
    private settingsService: SettingsService,
    public organizationService: OrganizationService
  ) {
    this.settingsService.updateList$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(() => {
        if (this.organization) {
          this.loadOrganizationUser(this.organization.ipAddress, this.organization.license_server_auth_token);
        }
      })

    this.form.controls.organization.valueChanges
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((org: OrganizationInterface) => {
        if (org.ipAddress && org.license_server_auth_token) {
          this.organization = org;
          this.loadOrganizationUser(org.ipAddress, org.license_server_auth_token);
        } else {
          alert('нет айпиадреса или токена, загрузить данные невозможно');
          this.dataSource.data = [];
          this.organization = undefined;
        }

      })

  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(false);
    this.unsubscribeAll.complete();
  }

  ngOnInit() {
    this.loadOrganizationList();
  }

  loadOrganizationList() {
    this.organizationService.loadOrganizationList()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((res: OrganizationInterface[]) => {
        this.options = res.map((item: OrganizationInterface) => {
          return {label: item.name, value: item}
        });
        this.drawFields();
      })
  }

  drawFields() {
    this.fields = [
      {
        key: 'organization',
        type: 'select',
        props: {
          label: 'Organization',
          placeholder: 'Select Organization',
          required: true,
          options: this.options
        }
      },
    ];
  }

  async loadOrganizationUser(ipAddress: string, token: string): Promise<void> {
    this.settingsService.getUserList(ipAddress, token)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((res: any) => {
        this.data = res.data;
        this.dataSource = new MatTableDataSource(this.data);
        if (this.sort) {
          this.dataSource.sort = this.sort;
        }

      })

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDetail(data?: ClientInterface) {
    if (!this.organization) {
      return
    }

    this.dinamicLoaderService.loadComponent$.next({
      component: UserFormComponent,
      data: cloneDeep({...data, organization: this.organization}),
    });
    setTimeout(() => {
      this.sidenavService.sideNavState$.next(true);
    });
  }


}
